<template>
  <section id="newsletter" class="newsletter-section">
    <div class="newsletter-section__inner">
      <div class="newsletter-section__text">
        <p class="eyebrow">The Letter</p>
        <h2>First look at new pieces</h2>
        <p>One-of-a-kind pieces sell quickly. Join the list to see new arrivals, artist stories and studio events before anyone else.</p>
      </div>
      <form class="newsletter-form" @submit.prevent>
        <label class="sr-only" for="nl-email">Your email address</label>
        <input id="nl-email" type="email" placeholder="Enter your email" class="newsletter-input" />
        <button type="submit" class="btn btn--dark">Subscribe</button>
      </form>
    </div>
  </section>
</template>

<script>
export default {
  name: 'NewsletterSection',
}
</script>

<style scoped>
.newsletter-section {
  background: var(--paper);
  padding: 9.6rem 4rem;
  scroll-margin-top: 10rem;
}

.newsletter-section__inner {
  max-width: var(--max-w);
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;
}

.newsletter-section__text h2 {
  font-size: clamp(3rem, 3.6vw, 4.2rem);
  font-weight: 400;
  margin: 1rem 0 1.2rem;
}

.newsletter-section__text p {
  font-size: 1.5rem;
  color: var(--stone);
  line-height: 1.65;
}

.newsletter-form {
  display: flex;
  gap: 1rem;
}

.newsletter-input {
  flex: 1;
  padding: 1.25rem 1.6rem;
  border: 1px solid var(--warm-grey);
  font-size: 1.4rem;
  font-family: var(--font);
  color: var(--ink);
  background: var(--canvas);
  border-radius: 0;
  outline: none;
  transition: border-color 0.15s;
}
.newsletter-input:focus { border-color: var(--charcoal); }
.newsletter-input::placeholder { color: var(--warm-grey); }

@media (max-width: 960px) {
  .newsletter-section { padding: 6.4rem 1.6rem; }
  .newsletter-section__inner { grid-template-columns: 1fr; }
}

@media (max-width: 640px) {
  .newsletter-form { flex-direction: column; }
}
</style>
